import { Link } from '@tanstack/react-router'
import { findNavItem } from '@/features/docs/config/navigation'

interface DocsBreadcrumbProps {
  slug: string
}

export function DocsBreadcrumb({ slug }: DocsBreadcrumbProps) {
  const found = findNavItem(slug)
  if (!found) return null

  return (
    <nav className="flex items-center gap-1.5 text-sm text-[var(--color-text-tertiary)] mb-6">
      <Link
        to="/docs/$"
        params={{ _splat: 'introduction' }}
        className="rounded-full transition-colors duration-300 ease-brisk hover:text-primary"
      >
        Docs
      </Link>
      <span className="material-symbols-outlined text-base">chevron_right</span>
      <span className="text-[var(--color-text-secondary)]">
        {found.section.title}
      </span>
      <span className="material-symbols-outlined text-base">chevron_right</span>
      <span className="text-[var(--color-text-primary)] font-medium">
        {found.item.title}
      </span>
    </nav>
  )
}
